<!-- Generated by GitHub Copilot - Oct-01-2026 -->
<!-- Breadcrumb -->
<nav class="breadcrumb" aria-label="Breadcrumb">
  <a routerLink="/admin" class="breadcrumb-link" (click)="goBack($event)">Admin</a>
  <span class="breadcrumb-separator" aria-hidden="true">&gt;</span>
  <a routerLink="/admin" [queryParams]="{ tab: 'audit' }" class="breadcrumb-link" (click)="goBack($event)">Audit Log</a>
  <span class="breadcrumb-separator" aria-hidden="true">&gt;</span>
  <span class="breadcrumb-item active">{{ logId }} — Event Detail</span>
</nav>

<div class="page-wrapper">
  @if (isLoading) {
  <div class="overlay" role="status" aria-live="polite">
    <div class="spinner" aria-hidden="true"></div>
    <p class="text-load">&nbsp;&nbsp; Loading...</p>
  </div>
  }

  @if (!isLoading && detail) {
  <div class="detail-container">
    <!-- Header -->
    <div class="detail-header">
      <h1>Event Detail</h1>
    </div>

    <!-- Summary panel -->
    <section class="summary-panel" aria-label="Event summary">
      <div class="summary-grid">
        <div class="summary-field">
          <span class="summary-label">Log ID</span>
          <span class="summary-value strong">{{ detail.logId }}</span>
        </div>
        <div class="summary-field">
          <span class="summary-label">Role</span>
          <span class="summary-value">{{ detail.role }}</span>
        </div>
        <div class="summary-field">
          <span class="summary-label">Record ID</span>
          <span class="summary-value">{{ detail.recordId }}</span>
        </div>

        <div class="summary-field">
          <span class="summary-label">Date &amp; Time</span>
          <span class="summary-value">{{ detail.dateTime | date:'dd-MMM-yyyy HH:mm' }}</span>
        </div>
        <div class="summary-field">
          <span class="summary-label">Module</span>
          <span class="summary-value strong">{{ detail.module }}</span>
        </div>
        <div class="summary-field">
          <span class="summary-label">Review Name</span>
          <span class="summary-value">{{ detail.reviewName }}</span>
        </div>

        <div class="summary-field">
          <span class="summary-label">Performed By</span>
          <span class="summary-value">{{ detail.performedBy }}</span>
        </div>
        <div class="summary-field">
          <span class="summary-label">Action Performed</span>
          <span class="summary-value">{{ detail.actionPerformed }}</span>
        </div>
        <div class="summary-field">
          <span class="summary-label">Status</span>
          <span class="summary-value strong">{{ detail.status }}</span>
        </div>
      </div>
    </section>

    <!-- Field changes -->
    <section class="changes-card" aria-label="Field changes">
      <div class="changes-head">
        <h2>Field Changes</h2>
        <span class="changes-badge">{{ detail.fieldChanges.length }} CHANGE{{ detail.fieldChanges.length === 1 ? '' : 'S' }}</span>
      </div>

      <div class="changes-table-wrapper">
        <table class="changes-table">
          <thead>
            <tr>
              <th scope="col">Field Name</th>
              <th scope="col"><span class="old-value-aligned">Old Value</span></th>
              <th scope="col">New Value</th>
            </tr>
          </thead>
          <tbody>
            @for (change of detail.fieldChanges; track change.fieldName) {
            <tr>
              <td>{{ change.fieldName }}</td>
              <td class="old-value">
                <span class="old-value-aligned">{{ change.oldValue }}</span>
                <span class="material-symbols-outlined change-arrow" aria-hidden="true">arrow_forward</span>
              </td>
              <td class="new-value">{{ change.newValue }}</td>
            </tr>
            }
            @if (detail.fieldChanges.length === 0) {
            <tr>
              <td colspan="3" class="changes-empty">No field changes were recorded for this event.</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  </div>
  }

  @if (!isLoading && !detail) {
  <div class="detail-empty" role="alert">No audit-log detail found for "{{ logId }}".</div>
  }
</div>
